import packageJson from '../../package.json';

export const environment = {
  production: false,
  appName: 'eSuprimentos',
  version: packageJson.version,
  logLevel: 0
};
